var map = {
	"./en.json": "edd4",
	"./en/about.json": "6633",
	"./en/faq.json": "e5ba",
	"./en/footer.json": "f79e",
	"./en/header.json": "632a",
	"./en/how.json": "a732",
	"./en/method.json": "b2e8",
	"./en/nav.json": "0baa",
	"./en/portfolio.json": "8b36",
	"./en/solutions.json": "5122",
	"./fr.json": "f693",
	"./fr/about.json": "b9c7",
	"./fr/faq.json": "adfd",
	"./fr/footer.json": "ea9b",
	"./fr/header.json": "98f9",
	"./fr/how.json": "9e3b",
	"./fr/method.json": "438b",
	"./fr/nav.json": "96e5",
	"./fr/portfolio.json": "db5c",
	"./fr/solutions.json": "483a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";